import { ComponentProps, ReactNode, forwardRef } from "react";
import DashboardContainer from "./dashboard/DashboardContainer";
import classNames from "classnames";

type DashboardContainerProps = {
  header?: ReactNode;
  children: ReactNode;
  className?: string;
  contentProps?: Omit<
    ComponentProps<typeof DashboardContainer.Content>,
    "children"
  >;
};

export const DashboardLayout = forwardRef<
  HTMLDivElement,
  DashboardContainerProps
>(({ header, children, className, contentProps }, ref) => {
  return (
    <DashboardContainer
      ref={ref}
      className={classNames("t-h-full", className || "")}
    >
      <DashboardContainer.Content
        {...contentProps}
        className={contentProps?.className ?? "t-mb-6"}
      >
        <div className="t-h-full t-w-full t-px-5 sm:t-px-3">
          {header}
          {children}
        </div>
      </DashboardContainer.Content>
    </DashboardContainer>
  );
});
